export default function (maxValue) {
    return function (value) {
        return ( new Date(maxValue) >= new Date(value));
    }
}
